export const translations = {
  en: {
    // Navigation
    'home': 'Home',
    'skills': 'Skills',
    'projects': 'Projects',
    'contact': 'Contact',
    'guestbook': 'Guestbook',
    
    // Banner
    'welcomeToPortfolio': 'Welcome to my Portfolio',
    'greeting': "Hi I'm Yi Si, ",
    'summary': "As a Master's student in Software Engineering, I have a strong foundation in programming, software development, and AI-driven applications. I am developing an eCommerce platform with AR shopping and a Clinical Decision Support Tool for hospital deployment. Seeking an internship to refine my skills and contribute to innovative technology.",
    
    // Guestbook
    'leaveMessage': 'Leave some message here :)',
    'nickname': 'Nickname',
    'message': 'Message',
    'submit': 'Submit',
    'submitting': 'Submitting...',
    'pastMessages': 'Past Messages',
    'noMessages': 'No messages yet. Be the first to leave one!',
    'loadingMessages': 'Loading messages...',
    
    // Language toggle
    'switchToEnglish': 'Switch to English',
    'switchToChinese': '切换到中文',
    
    // Projects component
    'viewProject': 'View Project',
    'technologiesUsed': 'Technologies Used',
    'toBeContinued': 'To Be Continued...',
    'projectSuggestion': 'Leave your project suggestions to me in my contact form :)',
    'arcommerce': 'ARCommerce',
    'safebite': 'SafeBite',
    'arcommerceDescription': 'A full-stack eCommerce platform using Spring Boot 3, Angular 18, and PostgreSQL, integrating Stripe payments and advanced product filtering. Enhanced user experience with AR shopping features for interactive product visualization.',
    'safebiteDescription': 'A full-stack restaurant application using Next.js and Prisma, integrating dietary preference filtering and allergen alerts to enhance user experience and safety. Users can easily find suitable menu options based on their specific dietary needs.',
    
    // Contact component
    'getInTouch': 'Get In Touch',
    'send': 'Send',
    'sending': 'Sending...',
    'formError': 'An error occurred. Please try again later.',
    
    // Newsletter component
    'subscribeNewsletter': 'Subscribe to My Newsletter',
    'validEmail': 'Please enter a valid email address',
    'subscribeSuccess': 'You have been successfully subscribed!',
    'subscribeFail': 'Failed to subscribe. Please try again later.',
    'somethingWrong': 'Something went wrong. Please try again later.'
  },
  zh: {
    // Navigation
    'home': '首页',
    'skills': '技能',
    'projects': '项目',
    'contact': '联系',
    'guestbook': '留言簿',
    
    // Banner
    'welcomeToPortfolio': '欢迎访问我的作品集',
    'greeting': '你好，我是司仪，',
    'summary': '作为软件工程硕士研究生，我在编程、软件开发和人工智能驱动的应用程序方面有扎实的基础。我正在开发一个具有AR购物功能的电子商务平台和一个用于医院部署的临床决策支持工具。寻求实习机会以提高我的技能并为创新技术做出贡献。',
    
    // Guestbook
    'leaveMessage': '在这里留言 :)',
    'nickname': '昵称',
    'message': '留言',
    'submit': '提交',
    'submitting': '提交中...',
    'pastMessages': '历史留言',
    'noMessages': '还没有留言。成为第一个留言的人！',
    'loadingMessages': '加载留言中...',
    
    // Language toggle
    'switchToEnglish': '切换到英文',
    'switchToChinese': 'Switch to Chinese',
    
    // Projects component
    'viewProject': '查看项目',
    'technologiesUsed': '使用的技术',
    'toBeContinued': '未完待续...',
    'projectSuggestion': '在联系表单中留下您的项目建议 :)',
    'arcommerce': 'AR电子商务',
    'safebite': '安全食品',
    'arcommerceDescription': '一个使用Spring Boot 3、Angular 18和PostgreSQL的全栈电子商务平台，集成了Stripe支付和高级产品筛选功能。通过AR购物功能增强用户体验，实现交互式产品可视化。',
    'safebiteDescription': '一个使用Next.js和Prisma的全栈餐厅应用程序，集成了饮食偏好筛选和过敏原警报，以提高用户体验和安全性。用户可以根据特定的饮食需求轻松找到合适的菜单选项。',
    
    // Contact component
    'getInTouch': '联系我',
    'send': '发送',
    'sending': '发送中...',
    'formError': '发生错误。请稍后再试。',
    
    // Newsletter component
    'subscribeNewsletter': '订阅我的邮件',
    'validEmail': '请输入有效的电子邮箱地址',
    'subscribeSuccess': '您已成功订阅！',
    'subscribeFail': '订阅失败。请稍后再试。',
    'somethingWrong': '出现问题。请稍后再试。'
  }
};